import React, { useMemo } from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import SubscribeButton from '../../../Button/SubscribeButton';
import { getDeviationSaleDetails } from '../../../utils/deviations';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

export const TierButton: React.FC<React.PropsWithChildren<Props>> = ({
  deviation,
  className,
}) => {
  // Only show the sale if the user has an eligible discount
  const { eligibleDiscount } = useMemo(
    () => getDeviationSaleDetails(deviation),
    [deviation]
  );

  return (
    <ActionBarItemWrapper>
      <SubscribeButton
        className={className}
        tier={deviation}
        withPrice
        withSaleIndicator={!!eligibleDiscount}
        showUnsubAsView
      />
    </ActionBarItemWrapper>
  );
};
TierButton.displayName = 'TierButton';

export default TierButton;
